export const getLocalString = (number: number): string =>
  number.toLocaleString('ja-JP');
